import apiClient from './client'
import type { User } from '@/types/auth'

/**
 * Auth API - Only /me endpoint needed
 * Login/Register/Logout are handled directly by Supabase Auth
 */
export const authApi = {
  /**
   * Get current authenticated user profile from backend
   * Backend validates Supabase JWT token and returns user profile
   */
  me: async (): Promise<User> => {
    const response = await apiClient.get('/auth/me')
    return response.data.user || response.data
  },
}
